import {useContext, useEffect} from 'react';
import {BrowserView} from 'react-device-detect';
import {Link} from 'react-router';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {useStoreTransmissions} from '../../../store/useStoreTransmissions.ts';
import Box from '../../ui/box/Box';
import AuthContext from '../../../contexts/AuthContext';
import {TransmissionsTab} from '../transmissions/TransmissionsTab.tsx';

export const DashboardTransmissions = () => {
    const {user} = useContext(AuthContext);
    const fetchTransmissionsDashboard = useStoreTransmissions(
        (state) => state.fetchTransmissionsDashboard,
    );
    const sortOrder = useStoreTransmissions((state) => state.sortOrder);

    useEffect(() => {
        fetchTransmissionsDashboard()
    }, [sortOrder])
    
    return (
        <>
            <BrowserView renderWithFragment={true}>
                <Box
                    boxName={'transmissions dashboard-transmissions'}
                    boxClassNames={'scroll flex-column mb-4'}
                    header={true}
                    headerClassNames={'rounded-top'}
                    headerTextColor={'white'}
                    headerContent={
                        <Row>
                            <Col className={'my-auto'}>
                                <h3 className="mr-3 my-auto">
                                    Mes dernières transmissions
                                </h3>
                            </Col>
                            <Col lg={6} className="d-flex justify-content-end">
                                {user.constraints?.transmitter && (
                                    <Link
                                        to={'../saisir-commande'}
                                        role={'button'}
                                        className={
                                            'btn d-flex align-items-center btn-sm ff-bold mr-2'
                                        }>
                                        Saisir une commande
                                    </Link>
                                )}

                                <Link
                                    to={'../transmissions'}
                                    role={'button'}
                                    className={
                                        'btn d-flex align-items-center btn-sm ff-bold'
                                    }>
                                    Voir tout
                                </Link>
                            </Col>
                        </Row>
                    }
                    boxContentClassNames={'rounded-bottom'}
                    content={
                        <TransmissionsTab />
                    }
                />
            </BrowserView>
        </>
    )
}
